import React from 'react';
import './About.css';

const About = () => {
  const stats = [
    { number: '25+', text: 'Years Experience', icon: '🌟' },
    { number: '1000+', text: 'Happy Clients', icon: '😊' },
    { number: '100%', text: 'Client Satisfaction', icon: '🎯' },
    { number: '24/7', text: 'Customer Support', icon: '💬' }
  ];

  const values = [
    {
      title: 'Quality',
      description: 'We never compromise on the quality of our work or materials.',
      icon: '🏆'
    },
    {
      title: 'Integrity',
      description: 'Honest communication and transparent business practices.',
      icon: '🤝'
    },
    {
      title: 'Innovation',
      description: 'Embracing new techniques and sustainable solutions.',
      icon: '💡'
    },
    {
      title: 'Reliability',
      description: 'Consistent, dependable service you can count on.',
      icon: '⭐'
    }
  ];

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const headerOffset = 100;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="about" id="about">
      <div className="container">
        <div className="section-title">
          <h2>About Us</h2>
          <p>Your Trusted Partner in Landscape Excellence</p>
        </div>
        
        <div className="about-content">
          <div className="about-text">
            <div className="about-header">
              <span className="highlight-badge">Est. 1998</span>
              <h3>Creating Beautiful Outdoor Spaces for Over 25 Years</h3>
            </div>
            <div className="text-content">
              <p>
                At Gardenia Landscaping LLC, we transform ordinary outdoor spaces into 
                extraordinary landscapes that reflect your unique style and enhance your quality of life.
                With over two decades of experience, we've built our reputation on quality,
                reliability, and attention to detail.
              </p>
              <p>
                Our team of certified professionals brings expertise in landscape design, 
                horticulture, and sustainable practices to every project. We proudly serve
                communities across <strong>Flagler County</strong> and <strong>Volusia County</strong>, including <strong>Palm Coast</strong>,
                <strong>Bunnell</strong>, <strong>Flagler Beach</strong>, <strong>Ormond Beach</strong>, and <strong>Daytona Beach</strong>.
              </p>
              <div className="certification-badge">
                <span>✓ Licensed & Insured</span>
                <span>✓ Professional Team</span>
                <span>✓ Satisfaction Guaranteed</span>
              </div>
            </div>
          </div>
          
          <div className="stats-container">
            {stats.map((stat, index) => (
              <div key={index} className="stat-box" data-aos="fade-up" data-aos-delay={index * 100}>
                <div className="stat-icon">{stat.icon}</div>
                <h3>{stat.number}</h3>
                <p>{stat.text}</p>
              </div>
            ))}
          </div>

          <div className="values-section">
            <h3>Our Core Values</h3>
            <div className="values-grid">
              {values.map((value, index) => (
                <div key={index} className="value-item" data-aos="fade-right" data-aos-delay={index * 100}>
                  <div className="value-icon">{value.icon}</div>
                  <h4>{value.title}</h4>
                  <p>{value.description}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="cta-section">
            <h3>Ready to Transform Your Outdoor Space?</h3>
            <p>Let's bring your landscaping vision to life!</p>
            <button onClick={() => scrollToSection('contact')} className="cta-button">Get Free Consultation</button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About; 